module.exports = __webpack_public_path__ + "assets/img/cover.b5b16e10.png";